export default __webpack_public_path__ + "static/media/Wallet-Hero.ebb6ee8a.jpg";